
  function showLoaderUp() {
    const loader = document.getElementById("transition_loader")
    if (loader && !loader.classList.contains("goUp")) {
      loader.classList.add("goUp")
      loader.classList.remove("goDown")
    }
  }
  
  function showLoaderDown() {
    const loader = document.getElementById("transition_loader")
    if (loader && !loader.classList.contains("goDown")) {
      loader.classList.add("goDown")
      loader.classList.remove("goUp")
    }
  }
  
  // Add transition effect on link clicks
  document.addEventListener('click', (event) => {
    const target = event.target.closest('a')
    if (target && target.href && !target.hasAttribute('target')) {
      event.preventDefault()
      showLoaderDown()
      setTimeout(() => {
        window.location.href = target.href
      }, 750)
    }
  })
  
  // Trigger loader hide after load or fallback timeout
  Promise.race([
    new Promise(resolve => window.addEventListener('load', resolve)),
    new Promise(resolve => setTimeout(resolve, 2000))
  ]).then(showLoaderUp)
  
  // Handle back/forward navigation via bfcache
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
      setTimeout(showLoaderUp, 50)
    }
  })
  
  // Fallback: if DOM is already ready (e.g., reload)
  if (document.readyState === 'complete') {
    setTimeout(showLoaderUp, 10)
  }


